import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {RouteService} from '../../../shared/services/route.service';
import {Stop} from '../../../shared/models/stop.model';
import {DataStorageService} from '../../../shared/services/data-storage.service';
import {Route} from '../../../shared/models/route.model';
import {EditingService} from '../../../shared/services/editing.service';
import {NgbDate, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {Ticket, TicketCreate, TicketUpdate} from '../../../shared/models/ticket.model';
import {Discount} from 'src/app/shared/models/discount.model';
import {ToolsService} from '../../../shared/services/tools.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DatePipe} from '@angular/common';
import {SendEmailService} from '../../../shared/services/send-email.service';
import {Reservation} from '../../../shared/models/reservation.model';
import swal from "sweetalert2";
import {BookingService} from '../../../shared/services/booking.service';
import {Vehicle} from '../../../shared/models/vehicle.model';
import {UserLogin} from '../../../shared/models/user.model';
import {AuthenticationService} from '../../../authentication/authentication.service';
import {take} from 'rxjs/operators';

@Component({
    selector: 'form-edit-ticket',
    templateUrl: 'form-edit-ticket.html',
})
export class FormEditTicketComponent implements OnInit, OnDestroy {
    @Input() ticket: Ticket;
    @Input() ticket_re: any; // Ticket or null
    @Input() is_discount_expired: boolean;
    @ViewChild('f') sendEmailForm: NgForm;
    @Input() reservation: Reservation;
    routingForm: FormGroup;


    isRoundTrip: boolean;
    DepPickstop: string;
    DepDropstop: string;
    RePickstop: string;
    ReDropstop: string;


    stops: Stop[] = [];

    availableDepStopFromOptions: any = [];
    availableReStopFromOptions: any = [];
    availableDepStopToOptions: any = [];
    availableReStopToOptions: any = [];

    min_date_re: any;
    is_blocked_user_dep: boolean;
    is_blocked_user_re: boolean;


    statusOptions: any = [{'value': ''}, {'value': 'confirmed'}, {'value': 'blocked'}];
    statusOptionsUser: any = [{'value': ''}, {'value': 'blocked'}];


    selectConfig: any = {
        labelField: 'value',
        valueField: 'value',
        searchField: ['value']
    };

    stopSelectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };

    date: string;

    availableDepRoutes: Route[] = [];
    availableReRoutes: Route[] = [];

    is_discount: boolean;
    discount_type = '';
    discount: Discount;

    blockedDates: any[] = [];
    is_blocked_dep: boolean;
    is_blocked_re: boolean;

    log_txt = '';

    error_message: string;
    user: UserLogin;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private routeService: RouteService,
                private dataStorageService: DataStorageService,
                private editingService: EditingService,
                private changeDetector: ChangeDetectorRef,
                private toolsService: ToolsService,
                private ngDateParserFormatter: NgbDateParserFormatter,
                private datePipe: DatePipe,
                private sendEmailService: SendEmailService,
                private bookingService: BookingService,
                private authenticationService: AuthenticationService) {
        this.is_discount = false;
        this.isRoundTrip = false;
        this.error_message = '';
    }

    ngOnInit() {

        this.stops = this.routeService.getStop();
        this.initStopOptions();

        this.initDiscount();

        if (this.ticket_re) {
            this.isRoundTrip = true;
        }

        this.initDepRoutes(this.ticket);
        if (this.isRoundTrip) {
            this.initReRoutes(this.ticket_re);
        }

        this.initRoutingForm();

        this.initInvoice();


        // rt, ow
        this.routingForm.get('tripType').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (value === 'rt') {
                        this.isRoundTrip = true;
                        this.toggleTicketRe(true);
                    } else if (value === 'ow') {
                        this.isRoundTrip = false;
                        this.toggleTicketRe(false);
                    }
                }
            );


        // blocked dates
        this.blockedDates = this.routeService.getBlockedDates();
        this.routeService.blockedDatesChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            blockedDates => {
                this.blockedDates = blockedDates;
            }
        );


        // discount valid_ticket? promo_code?
        this.editingService.discountInUseSub
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            value => {
                if (!this.toolsService.isEmpty(value)) {
                    this.discount_type = 'promo_code';
                    this.is_discount = true;
                    this.discount = value;
                    this.setDepRouteDiscountPrice();
                    if (this.isRoundTrip) {
                        this.setReRouteDiscountPrice();
                    }
                } else {
                    this.discount_type = '';
                    this.is_discount = false;
                    this.discount = null;
                }
            }
        );
        this.editingService.isValidTicketChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            value => {
                if (value) {
                    this.discount_type = 'valid_ticket';
                    this.is_discount = true;
                    this.bookingService.setIsValidTicket(true);
                    this.setDepRouteDiscountPrice();
                    if (this.isRoundTrip) {
                        this.setReRouteDiscountPrice();
                    }
                } else {
                    this.discount_type = '';
                    this.is_discount = false;
                    this.bookingService.setIsValidTicket(false);
                    this.setDepRoutePrice();
                    if (this.isRoundTrip) {
                        this.setReRoutePrice();
                    }
                }
                this.discount = null;
            }
        );


        // stop to
        this.routingForm.get('ticketDep').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const stops = this.routeService.setAvailableDepStopTo(value);
                    this.initDepStopToOptions(stops);

                }
            );

        this.routingForm.get('ticketRe').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const stops = this.routeService.setAvailableReStopTo(value);
                    this.initReStopToOptions(stops);
                }
            );


        // Set min return date
        this.routingForm.get('ticketDep').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                value => {
                    this.min_date_re = value;
                }
            );

        // available routes
        this.routingForm.get('ticketDep').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableDepRoutes('stopPick');
                }
            );

        this.routingForm.get('ticketDep').get('stopDrop').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableDepRoutes('stopDrop');
                }
            );

        this.routingForm.get('ticketDep').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableDepRoutes('date');
                    this.routingForm.get('ticketDep').get('routeDep').setValue(null);
                }
            );

        this.routingForm.get('ticketRe').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableReRoutes();
                    const stops = this.routeService.setAvailableReStopTo(value);
                    this.initReStopToOptions(stops);
                }
            );
        this.routingForm.get('ticketRe').get('stopDrop').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableReRoutes();
                }
            );
        this.routingForm.get('ticketRe').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableReRoutes();
                    this.routingForm.get('ticketRe').get('routeRe').setValue(null);
                }
            );

        // price
        this.routingForm.get('ticketDep').get('routeDep').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (value) {
                        this.checkIsBlocked(value.route_group_id, this.routingForm.get('ticketDep').get('date').value, 'dep');
                    }

                }
            );
        this.routingForm.get('ticketRe').get('routeRe').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (value) {
                        this.setInvoice();
                        this.checkIsBlocked(value.route_group_id, this.routingForm.get('ticketRe').get('date').value, 're');
                    }
                }
            );

        // submit
        this.editingService.setTicketsEmitter
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (reservation_id: number) => {
                this.onSubmitTickets(reservation_id);
            }
        );

        this.authenticationService.user.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            if (user) {
                this.user = user;
                if (user.level >= 3) {
                    const currentStatus = this.routingForm.get('ticketDep').get('status').value;
                    if (currentStatus === 'blocked') {
                        this.statusOptions = this.statusOptionsUser;
                    } else {
                        this.statusOptions = [{'value': ''}, {'value': 'confirmed'}, {'value': 'blocked'}];
                    }
                }
            }
        });
    }

    initRoutingForm() {
        if (this.ticket_re) {
            this.isRoundTrip = true;
        } else {
            this.isRoundTrip = false;
        }

        const dateDep = new NgbDate(
            +this.ticket.date.substring(0, 4),
            +this.ticket.date.substring(5, 7),
            +this.ticket.date.substring(8, 10));

        // set min return date
        this.min_date_re = dateDep;
        this.routingForm = new FormGroup({
            'tripType': new FormControl(this.ticket_re ? 'rt' : 'ow', Validators.required),
            'ticketDep': new FormGroup({
                'stopPick': new FormControl(this.ticket.route.pick_stop_id, Validators.required),
                'stopDrop': new FormControl(this.ticket.route.drop_stop_id, Validators.required),
                'date': new FormControl(dateDep, Validators.required),
                'routeDep': new FormControl(this.ticket.route, Validators.required),
                'status': new FormControl(this.ticket.status, Validators.required)
            }),
            'ticketRe': new FormGroup({
                'stopPick': new FormControl(null, Validators.required),
                'stopDrop': new FormControl(null, Validators.required),
                'date': new FormControl(null, Validators.required),
                'routeRe': new FormControl(null, Validators.required),
                'status': new FormControl('confirmed', Validators.required)
            })
        });

        if (this.isRoundTrip) {
            const dateRe = new NgbDate(
                +this.ticket_re.date.substring(0, 4),
                +this.ticket_re.date.substring(5, 7),
                +this.ticket_re.date.substring(8, 10));

            this.routingForm.patchValue({
                'ticketRe': {
                    'stopPick': this.ticket_re.route.pick_stop_id,
                    'stopDrop': this.ticket_re.route.drop_stop_id,
                    'date': dateRe,
                    'routeRe': this.ticket_re.route,
                    'status': this.ticket_re.status
                }
            });
            this.toggleTicketRe(true);
        } else {
            this.toggleTicketRe(false);
        }

    }

    initStopOptions() {
        for (const stop of this.stops) {
            this.availableDepStopFromOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
            this.availableReStopFromOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
        }
        for (const stop of this.stops) {
            this.availableDepStopToOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
            this.availableReStopToOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
        }

    }

    /*    setReStopPickOption(depPickStop) {
            const availableReStops = this.routeService.getAvailableReStopFrom(depPickStop);
            availableReStops.sort((a, b) => (a.id < b.id ? -1 : 1));
            if (availableReStops) {
                for (const stop of availableReStops) {
                    this.availableReStopFromOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
                }
            }
        }*/

    initDepStopToOptions(stops) {
        // stops 배열을 id 기준으로 정렬
        const sortedStops = [...stops].sort((a, b) => (a.id < b.id ? -1 : 1));
        for (const stop of sortedStops) {
            this.availableDepStopToOptions.push({'value': stop.id, 'label': stop.title});
        }
    }

    initReStopToOptions(stops) {
        // stops 배열을 id 기준으로 정렬
        const sortedStops = [...stops].sort((a, b) => (a.id < b.id ? -1 : 1));
        for (const stop of sortedStops) {
            this.availableReStopToOptions.push({'value': stop.id, 'label': stop.title});
        }
    }

    initDiscount() {
        if (this.editingService.getDiscountInUse()) {
            this.discount_type = 'promo_code';
            this.is_discount = true;
            this.discount = this.editingService.getDiscountInUse();
        }
        if (this.editingService.getIsValidTicket()) {
            this.discount_type = 'valid_ticket';
            this.is_discount = true;
        }
    }

    initDepRoutes(ticket) {
        this.availableDepRoutes = this.routeService.setSelectedDepRoute(
            ticket.route.pick_stop_id,
            ticket.route.drop_stop_id,
            ticket.date
        ).sort((a, b) => a.route_group_id - b.route_group_id);
    }

    initReRoutes(ticket) {
        this.availableReRoutes = this.routeService.setSelectedReRoute(
            ticket.route.pick_stop_id,
            ticket.route.drop_stop_id,
            ticket.date
        ).sort((a, b) => a.route_group_id - b.route_group_id);
        if (this.is_discount) {
            this.setReRouteDiscountPrice();
        }
    }

    initInvoice() {
        if (this.isRoundTrip) {
            this.editingService.setPrice(
                this.routingForm.get('ticketDep').get('routeDep').value.adult_price,
                this.routingForm.get('ticketDep').get('routeDep').value.child_price,
                this.routingForm.get('ticketDep').get('routeDep').value.infant_price,
                this.routingForm.get('ticketRe').get('routeRe').value.adult_price,
                this.routingForm.get('ticketRe').get('routeRe').value.child_price,
                this.routingForm.get('ticketRe').get('routeRe').value.infant_price
            );
        } else {
            this.editingService.setPrice(
                this.routingForm.get('ticketDep').get('routeDep').value.adult_price,
                this.routingForm.get('ticketDep').get('routeDep').value.child_price,
                this.routingForm.get('ticketDep').get('routeDep').value.infant_price,
                0,
                0,
                0
            );
        }
    }

    setDepRoutePrice() {
        for (const availableRoute of this.availableDepRoutes) {
            availableRoute.adult_price = 70;
        }
    }

    setReRoutePrice() {
        for (const availableRoute of this.availableReRoutes) {
            availableRoute.adult_price = 70;
        }
    }

    setDepRouteDiscountPrice() {
        if (this.discount_type === 'valid_ticket') {
            for (const selectedRoute of this.availableDepRoutes) {
                selectedRoute.discount_price = 0;
            }
            return;
        }

        // BOGO: amount is a PERCENT (e.g. 50 = 50% off)
        // Regular promo: amount is a FIXED $ off
        const isBogo = this.isBogoCode(this.discount && this.discount.code);
        const pct = isBogo ? Math.max(0, Math.min(100, +this.discount.amount)) / 100 : 0;
        const fixed = isBogo ? 0 : +this.discount.amount;

        for (const selectedRoute of this.availableDepRoutes) {
            // adult-price-based preview; per-passenger-type display is handled
            // in the "Customer Paid Fare" panel separately
            selectedRoute.discount_price = isBogo
                ? +selectedRoute.adult_price * (1 - pct)
                : +selectedRoute.adult_price - fixed;
        }
    }

    setReRouteDiscountPrice() {
        if (this.discount_type === 'valid_ticket') {
            for (const selectedRoute of this.availableReRoutes) {
                selectedRoute.discount_price = 0;
            }
            return;
        }

        const isBogo = this.isBogoCode(this.discount && this.discount.code);
        const pct = isBogo ? Math.max(0, Math.min(100, +this.discount.amount)) / 100 : 0;
        const fixed = isBogo ? 0 : +this.discount.amount;

        for (const selectedRoute of this.availableReRoutes) {
            selectedRoute.discount_price = isBogo
                ? +selectedRoute.adult_price * (1 - pct)
                : +selectedRoute.adult_price - fixed;
        }
    }

    /**
     * BOGO is identified by the code containing "bogo" (case-insensitive).
     * Mirrors the same convention used elsewhere in the project.
     */
    private isBogoCode(code: string | null | undefined): boolean {
        if (!code) { return false; }
        return code.toLowerCase().indexOf('bogo') >= 0;
    }

    setAvailableDepRoutes(changed_option: string) {
        this.availableDepRoutes = this.routeService.setSelectedDepRoute(
            this.routingForm.get('ticketDep').get('stopPick').value,
            this.routingForm.get('ticketDep').get('stopDrop').value,
            this.routingForm.get('ticketDep').get('date').value
        ).sort((a: any, b: any) => {
            return a.pick_time > b.pick_time ? 1 : -1;
        });
        // check if valid travel date for discount
        if (changed_option === 'date' && this.is_discount && this.discount) {
            const new_date = this.ngDateParserFormatter.format(this.routingForm.get('ticketDep').get('date').value);
            if (!(this.discount.start <= new_date && this.discount.end >= new_date)) {
                this.editingService.resetDiscount();
            }
        }
        if (this.is_discount && !this.is_discount_expired) {
            this.setDepRouteDiscountPrice();
        }
    }

    setAvailableReRoutes() {
        this.availableReRoutes = this.routeService.setSelectedReRoute(
            this.routingForm.get('ticketRe').get('stopPick').value,
            this.routingForm.get('ticketRe').get('stopDrop').value,
            this.routingForm.get('ticketRe').get('date').value
        ).sort((a: any, b: any) => {
            return a.pick_time > b.pick_time ? 1 : -1;
        });
        if (this.is_discount && !this.is_discount_expired) {
            this.setReRouteDiscountPrice();
        }
    }

    toggleTicketRe(value) {
        this.isRoundTrip = value;
        const ticketReControl = this.routingForm.get('ticketRe');
        if (value) {
            ticketReControl.get('stopPick').enable();
            ticketReControl.get('stopDrop').enable();
            ticketReControl.get('date').enable();
        } else {
            ticketReControl.get('stopPick').disable();
            ticketReControl.get('stopDrop').disable();
            ticketReControl.get('date').disable();
        }
    }

    checkIsBlocked(route_group_id: number, date: any, kind: string) {
        date = date.year + '-' + date.month + '-' + date.day;
        const new_date = this.datePipe.transform(date, 'yyyy-MM-dd');
        const route_group = this.routeService.getRouteGroupById(route_group_id);
        const dispatch_group_id = route_group.dispatch_group_id;

        if (kind === 'dep') {
            this.is_blocked_dep =
                this.blockedDates.some(el => el.date === new_date && el.dispatch_group_id === dispatch_group_id);
            if (this.is_blocked_dep) {
                this.routingForm.patchValue({ticketDep: {status: 'blocked'}});
            }
        } else if (kind === 're') {
            this.is_blocked_re =
                this.blockedDates.some(el => el.date === new_date && el.dispatch_group_id === dispatch_group_id);
            if (this.is_blocked_re) {
                this.routingForm.patchValue({ticketRe: {status: 'blocked'}});
            }
        }
    }

    setInvoice() {
        if (this.is_discount_expired) {
            if (this.isRoundTrip) {
                // departure change
                if (this.ticket.route_id !== this.routingForm.get('ticketDep').get('routeDep').value.id) {
                    this.editingService.setPrice(
                        +this.routingForm.get('ticketDep').get('routeDep').value.adult_price + +this.discount.amount,
                        +this.routingForm.get('ticketDep').get('routeDep').value.child_price + +this.discount.amount,
                        +this.routingForm.get('ticketDep').get('routeDep').value.infant_price + +this.discount.amount,
                        this.routingForm.get('ticketRe').get('routeRe').value.adult_price,
                        this.routingForm.get('ticketRe').get('routeRe').value.child_price,
                        this.routingForm.get('ticketRe').get('routeRe').value.infant_price
                    );
                } else {
                    if (this.ticket_re) {
                        if (this.ticket_re.route_id !== this.routingForm.get('ticketRe').get('routeRe').value.id) {
                            // return change
                            this.editingService.setPrice(
                                this.routingForm.get('ticketDep').get('routeDep').value.adult_price,
                                this.routingForm.get('ticketDep').get('routeDep').value.child_price,
                                this.routingForm.get('ticketDep').get('routeDep').value.infant_price,
                                +this.routingForm.get('ticketRe').get('routeRe').value.adult_price + +this.discount.amount,
                                +this.routingForm.get('ticketRe').get('routeRe').value.child_price + +this.discount.amount,
                                +this.routingForm.get('ticketRe').get('routeRe').value.infant_price + +this.discount.amount
                            );
                        }
                    } else {
                        // return add
                        this.editingService.setPrice(
                            this.routingForm.get('ticketDep').get('routeDep').value.adult_price,
                            this.routingForm.get('ticketDep').get('routeDep').value.child_price,
                            this.routingForm.get('ticketDep').get('routeDep').value.infant_price,
                            +this.routingForm.get('ticketRe').get('routeRe').value.adult_price + +this.discount.amount,
                            +this.routingForm.get('ticketRe').get('routeRe').value.child_price + +this.discount.amount,
                            +this.routingForm.get('ticketRe').get('routeRe').value.infant_price + +this.discount.amount
                        );
                    }
                }
            } else {
                this.editingService.setPrice(
                    +this.routingForm.get('ticketDep').get('routeDep').value.adult_price + +this.discount.amount,
                    +this.routingForm.get('ticketDep').get('routeDep').value.child_price + +this.discount.amount,
                    +this.routingForm.get('ticketDep').get('routeDep').value.infant_price + +this.discount.amount,
                    0,
                    0,
                    0
                );
            }
        } else {
            if (this.isRoundTrip) {
                this.editingService.setPrice(
                    this.routingForm.get('ticketDep').get('routeDep').value.adult_price,
                    this.routingForm.get('ticketDep').get('routeDep').value.child_price,
                    this.routingForm.get('ticketDep').get('routeDep').value.infant_price,
                    this.routingForm.get('ticketRe').get('routeRe').value.adult_price,
                    this.routingForm.get('ticketRe').get('routeRe').value.child_price,
                    this.routingForm.get('ticketRe').get('routeRe').value.infant_price
                );
            } else {
                this.editingService.setPrice(
                    this.routingForm.get('ticketDep').get('routeDep').value.adult_price,
                    this.routingForm.get('ticketDep').get('routeDep').value.child_price,
                    this.routingForm.get('ticketDep').get('routeDep').value.infant_price,
                    0,
                    0,
                    0
                );
            }
        }
    }


    // Submit

    onSubmitTickets(reservation_id: number) {

        this.setTimeForCheckError();

        // Departure Ticket
        const ticketDepDateRaw = this.routingForm.value.ticketDep.date;
        const ticketDepDate = this.ngDateParserFormatter.format(ticketDepDateRaw);
        if (this.ticket.date === ticketDepDate
            && this.ticket.route.id === this.routingForm.value.ticketDep.routeDep.id
            && this.ticket.status === this.routingForm.value.ticketDep.status
        ) {
            // same
        } else {
            // update
            const newTicketDep =
                new TicketUpdate(this.ticket.id, ticketDepDate,
                    this.routingForm.value.ticketDep.routeDep.id, reservation_id, this.routingForm.value.ticketDep.status);

            for (const selectedDepRoute of this.availableDepRoutes) {
                this.DepPickstop = selectedDepRoute.pick_stop.title;
                this.DepDropstop = selectedDepRoute.drop_stop.title;
            }
            this.dataStorageService.updateTicket(newTicketDep)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                if (responseData['error']) {
                    // error!
                    this.error_message += 'Error occurred on departure ticket update. ';
                } else {
                    this.addBlockDateAfterCheck(newTicketDep.date, newTicketDep.route_id);
                    // log
                    if (this.ticket.date !== ticketDepDate) {
                        this.log_txt += 'Departure date changed from '
                            + this.ticket.date
                            + ' to ' + ticketDepDate + '.<br>';
                    }
                    //DEP route
                    if (this.ticket.route.id !== this.routingForm.value.ticketDep.routeDep.id) {
                        if (this.ticket.route.pick_stop_id !== this.routingForm.value.ticketDep.stopPick) //pic
                        {
                            /*
                                                               + ' to ' + this.routingForm.value.ticketDep.stopPick + '.<br>';
                            */

                            this.log_txt += 'Departure Pickup location changed from '
                                + this.ticket.route.pick_stop.title
                                + ' to ' + this.DepPickstop + '.<br>';

                        }
                        if (this.ticket.route.drop_stop_id !== this.routingForm.value.ticketDep.stopDrop) //drop
                        {
                            /*
                                                            this.log_txt += 'Departure Drop location changed from '
                                                              + this.ticket.route.drop_stop_id
                                                              + ' to ' + this.routingForm.value.ticketDep.stopDrop + '.<br>';
                            */

                            this.log_txt += 'Departure Drop location changed from '
                                + this.ticket.route.drop_stop.title
                                + ' to ' + this.DepDropstop + '.<br>';

                        }
                    }

                    if (this.ticket.status !== this.routingForm.value.ticketDep.status) {
                        this.log_txt += 'Departure status changed from '
                            + this.ticket.status
                            + ' to ' + this.routingForm.value.ticketDep.status + '.<br>';

                    }
                }
            });
        }


        // Returning Ticket
        if (this.isRoundTrip) {
            const ticketReDateRaw = this.routingForm.value.ticketRe.date;
            const ticketReDate = this.ngDateParserFormatter.format(ticketReDateRaw);
            if (this.ticket_re) {
                if (this.ticket_re.date === ticketReDate
                    && this.ticket_re.route.id === this.routingForm.value.ticketRe.routeRe.id
                    && this.ticket_re.status === this.routingForm.value.ticketRe.status) {
                    // same
                } else {
                    // update
                    const newTicketRe =
                        new TicketUpdate(this.ticket_re.id, ticketReDate,
                            this.routingForm.value.ticketRe.routeRe.id, reservation_id, this.routingForm.value.ticketRe.status);
                    for (const selectedReRoute of this.availableReRoutes) {
                        this.RePickstop = selectedReRoute.pick_stop.title;
                        this.ReDropstop = selectedReRoute.drop_stop.title;

                    }
                    this.dataStorageService.updateTicket(newTicketRe)
                        .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                        if (responseData['error']) {
                            // error!
                            this.error_message += 'Error occurred on return ticket update. ';
                        } else {
                            this.addBlockDateAfterCheck(newTicketRe.date, newTicketRe.route_id);
                            // log
                            if (this.ticket_re.date !== ticketReDate) {
                                this.log_txt += 'Returning date changed from '
                                    + this.ticket_re.date
                                    + ' to ' + ticketReDate + '.<br>';
                            }
                            //RE route
                            if (this.ticket_re.route.id !== this.routingForm.value.ticketRe.routeRe.id) {
                                if (this.ticket_re.route.pick_stop_id !== this.routingForm.value.ticketRe.stopPick) //pic
                                {
                                    /*                                        this.log_txt += 'Returning Pickup location changed from '
                                                                              + this.ticket_re.route.pick_stop_id
                                                                              + ' to ' + this.routingForm.value.ticketRe.stopPick + '.<br>';*/

                                    this.log_txt += 'Returning Pickup location changed from '
                                        + this.ticket_re.route.pick_stop.title
                                        + ' to ' + this.RePickstop + '.<br>';

                                }
                                if (this.ticket_re.route.drop_stop_id !== this.routingForm.value.ticketRe.stopDrop) //drop
                                {
                                    /*                                            this.log_txt += 'Returning Drop location changed from '
                                                                                  + this.ticket_re.route.drop_stop_id
                                                                                  + ' to ' + this.routingForm.value.ticketRe.stopDrop + '.<br>';*/

                                    this.log_txt += 'Returning Drop location changed from '
                                        + this.ticket_re.route.drop_stop.title
                                        + ' to ' + this.ReDropstop + '.<br>';

                                }
                            }

                            if (this.ticket_re.status !== this.routingForm.value.ticketRe.status) {
                                this.log_txt += 'Returning status changed from '
                                    + this.ticket_re.status
                                    + ' to ' + this.routingForm.value.ticketRe.status + '.<br>';

                                /*                                    if(this.routingForm.value.ticketDep.status == 'confirmed') //blocked to confirmed has been changed.AUTO SEND EMAIL
                                                                    {
                                                                            // send confirmation email.
                                                                            this.onSendEmail(reservation_id);
                                                                    }*/
                            }
                        }
                    });
                }
            } else {
                // create new
                const newTicketRe =
                    new TicketCreate(ticketReDate,
                        this.routingForm.value.ticketRe.routeRe.id, reservation_id, this.routingForm.value.ticketRe.status);
                this.dataStorageService.createTicket(newTicketRe)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                    if (responseData['error']) {
                        // error
                        this.error_message += 'Error occurred on return ticket create. ';
                    } else {
                        this.addBlockDateAfterCheck(newTicketRe.date, newTicketRe.route_id);
                        // log
                        this.log_txt += 'Returning date ' + ticketReDate + 'added.<br>';
                        this.log_txt += 'Returning route ' + this.routingForm.value.ticketRe.route.id + 'added.<br>';
                        this.log_txt += 'Returning status ' + this.routingForm.value.ticketRe.status + 'added.<br>';
                    }
                });
            }
        } else {
            if (this.ticket_re) {
                // delete return trip
                this.dataStorageService.deleteTicket(this.ticket_re.id)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                    responseData => {
                        if (responseData['error']) {
                            // error
                            this.error_message += 'Error occurred on return ticket delete';
                        } else {
                            // log
                            this.log_txt += 'Returning trip canceled. ( '
                                + this.ticket_re.date + ' / ' + this.ticket_re.route.id
                                + ' / ' + this.ticket_re.status + ').<br>';
                        }
                    }
                );
            }
        }

    }

    setTimeForCheckError() {
        setTimeout(() => {
            if (this.error_message === '') {
                // give signal to edit-reservation
                this.editingService.log_txt_sub.next(this.log_txt);
            } else {
                // error
                this.editingService.error_message_sub.next(this.error_message);
            }
        }, 1000);
    }


    /* Add Block Date if exceed */
    addBlockDateAfterCheck(date: string, route_id: number) {
        const dispatch_group_id = this.routeService.getDispatchGroupIdByRouteId(route_id);
        this.dataStorageService.addBlockDateAfterCheck(date, dispatch_group_id, this.editingService.getTotalNum());
    }


    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    onSendEmail(reservation_id: number) {
        this.dataStorageService.fetchReservation(reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            reservation => {
                const emailObj = {
                    type: 1,
                    email_to: reservation.email,
                    reservation: reservation
                };
                this.sendEmailService.initEmail(emailObj);
                this.initForm();
                //alert('Email sent');
            }
        )
    }

    initForm() {
        this.sendEmailForm.form.patchValue({
            email: this.reservation.email
        });
    }
}
